import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PoModule } from '@po-ui/ng-components';
import { BarchartModule } from 'src/app/cp-barchart/cp-barchart.module';
import { BarsChartModule } from 'src/app/cp-barschart/cp-barschart.module';
import { DonutChartModule } from 'src/app/cp-donutchart/cp-donutchart.module';
import { GaugeChartModule } from 'src/app/cp-gauge/cp-gauge.module';
import { LoadingButtonModule } from 'src/app/cp-loadingbutton/cp-loadingbutton.module';
import { ProgressChartModule } from 'src/app/cp-progresschart/cp-progresschart.module';
import { TaskChartsComponent } from './taskcharts.component';
import { TaskContractComponent } from './taskcontract/taskcontract.component';
import { TaskCostComponent } from './taskcost/taskcost.component';
import { TaskOrderExtrasComponent } from './taskorderextras/taskorderextras.component';
import { TaskOrdersComponent } from './taskorders/taskorders.component';
import { TaskStatusComponent } from './taskstatus/taskstatus.component';

@NgModule({
  declarations: [
    TaskChartsComponent,
    TaskStatusComponent,
    TaskOrdersComponent,
    TaskContractComponent,
    TaskCostComponent,
    TaskOrderExtrasComponent
  ],
  imports: [
    CommonModule,
    PoModule,
    BarchartModule,
    BarsChartModule,
    DonutChartModule,
    GaugeChartModule,
    ProgressChartModule,
    LoadingButtonModule
  ],
  exports: [
    TaskChartsComponent,
    TaskStatusComponent,
    TaskOrdersComponent,
    TaskContractComponent,
    TaskCostComponent,
    TaskOrderExtrasComponent
  ]
})
export class TaskChartsModule {}
